import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import "../App.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { nameState, phoneState, emailState, orderIdState } from "../atoms";
import { useRecoilState } from "recoil";
import { baseUrl } from "../constants";

function HomePage() {
  const { hotelId, shopId, tableId, tableNumber } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [name, setName] = useRecoilState(nameState);
  const [phone, setPhone] = useRecoilState(phoneState);
  const [email, setEmail] = useRecoilState(emailState);
  const [orderId, setOrderId] = useRecoilState(orderIdState);
  const [errors, setErrors] = useState({});
  const [shopName, setShopName] = useState("");

  const getShopDetails = () => {
    axios
      .get(
        `${baseUrl}/core/api/v1/shop/category/get-one?hotelId=${hotelId}&shopId=${shopId}`
      )
      .then((res) => setShopName(res.data.shop_name))
      .catch((err) => console.error(err));
  };
  const getTableSatus = () => {
    axios
      .get(
        `${baseUrl}/core/api/v1/orders/get-running-order?tableId=${tableId}&shopId=${shopId}&hotel_id=${hotelId}&hotelId=${hotelId}`
      )
      .then((res) => {
        if (Object.entries(res.data).length > 0) {
          if (res.data.order_status === "RUNNING") {
            setName(res.data.cust_name);
            setPhone(res.data.cust_phone);
            setEmail(res.data.cust_email);
            setOrderId(res.data.id);
            navigate(`/cat/${hotelId}/${shopId}/${tableId}/${tableNumber}`);
          }
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getTableSatus();
    getShopDetails();
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      navigate(`/cat/${hotelId}/${shopId}/${tableId}/${tableNumber}`);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          p: isMobile ? 2 : 4,
          mt: 4,
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Typography
          variant={isMobile ? "h6" : "h5"}
          align="center"
          gutterBottom
          style={{ color: "gray" }}
        >
          You are placing an order for
        </Typography>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          align="center"
          gutterBottom
        >
          {shopName}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
            required
            error={!!errors.name}
            helperText={errors.name}
            size={isMobile ? "small" : "medium"}
            variant="standard"
          />
          <TextField
            fullWidth
            label="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            margin="normal"
            required
            error={!!errors.phone}
            helperText={errors.phone}
            size={isMobile ? "small" : "medium"}
            variant="standard"
            inputProps={{ maxLength: 10 }}
          />
          <TextField
            fullWidth
            label="Email (optional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            size={isMobile ? "small" : "medium"}
            variant="standard"
          />
          <Button
            type="submit"
            fullWidth
            variant="custom-button"
            sx={{ mt: 3, py: isMobile ? 1 : 1.5 }}
          >
            Proceed
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default HomePage;
